module.exports = __webpack_public_path__ + "static/media/sectores.abb3e2a3.png";